import { AppPaths } from "@p0security/shared/routes/constants";
import { NotFound } from "components/App/NotFound";
import { JitPaths } from "components/Jit/paths";

export const RequestNotFound: React.FC<{ orgSlug?: string }> = ({
  orgSlug,
}) => (
  <NotFound
    title="Request Not Found"
    backButton={{
      label: "Back to all requests",
      navigateTo: `/o/${orgSlug}/${AppPaths.AccessManagement}/${JitPaths.Activity}`,
    }}
  />
);
